import React from 'react';
import { Hero } from './components/Hero';
import { SocialProofBar } from './components/SocialProofBar';
import { Testimonials } from './components/Testimonials';
import { PainGrid } from './components/PainGrid';
import { ProductReveal } from './components/ProductReveal';
import { LookInside } from './components/LookInside';
import { Tomes } from './components/Tomes';
import { Bonuses } from './components/Bonuses';
import { Urgency } from './components/Urgency';
import { Pricing } from './components/Pricing';
import { ValueStack } from './components/ValueStack';
import { Guarantee } from './components/Guarantee';
import { Faq } from './components/Faq';
import { CostOfInaction } from './components/CostOfInaction';
import { Close } from './components/Close';
import { Footer } from './components/Footer';
import { MetaPixel } from './components/MetaPixel';
import { Vol5Carousel } from './pages/Vol5Carousel';
import { painVoices, wantVoices } from './data/testimonials';

/*
 * Notificaciones de compra (components/PurchaseNotifications.tsx) apagadas:
 * DPS-33 todavía no tiene compradores reales. Volver a montarlas solo con
 * datos reales de ventas.
 */
export function App({
  view = 'landingPage'
}: {
  view?: 'landingPage' | 'vol5Carousel';
}) {
  if (view === 'vol5Carousel') return <Vol5Carousel data-id="element-0" data-mp="5yhgo69t1c8" />;
  return <div className="min-h-screen w-full bg-navy text-white font-sans selection:bg-gold selection:text-gold-ink" data-id="element-1" data-mp="4wvvprmowg9">
      <MetaPixel data-id="element-2" data-mp="2zmenq84nlk7i" />
      <main data-id="element-3" data-mp="2zmwggus3xgao">
        <Hero data-id="element-4" data-mp="2zng1ikd20ksx" />
        <SocialProofBar data-id="element-5" data-mp="33mowfsjtyoq2" />
        <PainGrid data-id="element-6" data-mp="33lwzadal4ixo" />
        <Testimonials voices={painVoices} title="You’re not the only one" subtitle="What softball coaches told us they need — and where each one is already solved inside the pack." background="white" data-id="element-7" data-mp="33nggq77z9011" />
        <ProductReveal data-id="element-8" data-mp="nvj3jfxq0epq" />
        <LookInside data-id="element-9" data-mp="nwc39wy9i3yd" />
        <Tomes data-id="element-10" data-mp="nur8q7by6l0i" />
        <Bonuses data-id="element-11" data-mp="nvar1p5ifbf2" />
        <ValueStack data-id="element-12" data-mp="nxww9i4xheu4" />
        <Urgency data-id="element-13" data-mp="sudlkfnv5z8s" />
        <Pricing data-id="element-14" data-mp="studdqo0mp7y" />
        <Guarantee data-id="element-15" data-mp="stc6m03q8sls" />
        <Faq data-id="element-16" data-mp="ssssyvl40qdk" />
        <Testimonials voices={wantVoices} eyebrow="From coaches using it" title="How coaches fit it into their season" subtitle="It works alongside the way you already coach — not instead of it." background="cream" data-id="element-17" data-mp="swgmhuqk1csa" />
        <CostOfInaction data-id="element-18" data-mp="d3wd97kipiu2" />
        <Close data-id="element-19" data-mp="d2bhxfqdpvv5" />
      </main>
      <Footer data-id="element-20" data-mp="851n1kk80rzx" />
    </div>;
}